import { camelizeKeys } from 'humps';
import { prop } from 'ramda';
import { get } from '@namespace/helpers';

interface IGetJackpotByProviderParams {
  providerId: string;
  currencyCode: string;
  jackpotCode: string;
}

interface ILevel {
  winAmount: string;
  largestWinAmount: string;
  currentWinAmount: string;
}

interface IGetJackpotByProviderResponse {
  source_type: 'provider';
  levels: Record<string, ILevel>;
}

export const getJackpotByProvider = ({
  providerId,
  currencyCode,
  jackpotCode
}: IGetJackpotByProviderParams): Promise<Record<string, ILevel>> => {
  let url = `/ihub/jackpot/?service_id=${providerId}&currency=${currencyCode}`;
  if (jackpotCode != null) {
    url += `&code=${jackpotCode}`;
  }

  return get<IGetJackpotByProviderResponse>(url)
    .then((response) => camelizeKeys<IGetJackpotByProviderResponse>(response))
    .then(prop('levels'));
};
